import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '..';
import type { OpenAiDescription } from '../../components/parser/ParserTypes';

export interface OpenAiDescriptionsState {
  descriptionsByOrg: {
    [crmOrgId: string]: { [metadataId: string]: OpenAiDescription };
  };
}

const initialState: OpenAiDescriptionsState = {
  descriptionsByOrg: {},
};

export const openAiDescriptionsSlice = createSlice({
  name: 'openAiDescriptions',
  initialState,
  reducers: {
    setOpenAiDescription: (
      state,
      action: PayloadAction<{
        crmOrgId: string;
        metadataId: string;
        description: OpenAiDescription;
      }>,
    ) => {
      const { crmOrgId, metadataId, description } = action.payload;
      if (!state.descriptionsByOrg[crmOrgId]) {
        state.descriptionsByOrg[crmOrgId] = {};
      }
      state.descriptionsByOrg[crmOrgId][metadataId] = description;
    },
  },
});

export const { setOpenAiDescription } = openAiDescriptionsSlice.actions;

export const selectOpenAiDescription =
  (crmOrgId: string, metadataId: string) => (state: RootState) =>
    state[openAiDescriptionsSlice.name]?.descriptionsByOrg[crmOrgId]?.[metadataId];

export default openAiDescriptionsSlice.reducer;
